import { clone, mergeDeepWith } from 'ramda';
import { regexp } from 'js/utils/Validation/validationRules';
import { defaults } from 'js/utils/Validation/validationMethods';

export const basicValidation = {
    amount: {
        required: true,
        money: { error: 'playtech.mobile.system.tooltip.amount' },
        range: { error: 'playtech.mobile.system.mobile-cashier.amount.tooltip.range' }
    },
    accountId: {
        required: true
    },
    cvv2: {
        required: true,
        length: {
            min: 3,
            max: 4,
            error: 'playtech.mobile.system.mobile-cashier.error.cvv2.length'
        },
        regexp: {
            re: /^$|^\d+$/,
            error: 'playtech.mobile.system.mobile-cashier.error.cvv2.regexp'
        }
    }
};

export const accountIdEmailValidation = {
    required: true,
    regexp: defaults.email
};

export const promoCodeValidation = [
    regexp({
        re: /^[A-Za-z0-9]+$/,
        error: 'playtech.mobile.system.mobile-cashier.promoCode.regexp'
    })
];

export const deposit = {
    generic: {
        validationConfig: {
            ...basicValidation,
            requiredPredefinedValue: {
                required: true
            }
        }
    },
    basic: {
        validationConfig: basicValidation
    },
    PayPal: {
        validationConfig: {
            ...basicValidation,
            accountId: accountIdEmailValidation
        }
    },
    Moneybookers: {
        validationConfig: {
            ...basicValidation,
            accountId: accountIdEmailValidation
        }
    },
    WebMoney: {
        validationConfig: {
            ...basicValidation,
            accountId: {
                ...basicValidation.accountId,
                regexp: {
                    re: /^[A-Z][0-9]{12}$/,
                    error: 'playtech.mobile.system.mobile-cashier.method.WebMoney.accountId.format.tooltip'
                }
            }
        }
    },
    QIWIviaSC: {
        accountFieldsMap: {
            field1: 'accountId'
        }
    },
    PaySafeCard: {},
    Envoy: {
        validationConfig: {
            ...basicValidation,
            amount: {
                ...basicValidation.amount,
                required: false
            }
        }
    },
    PrePaidCard: {
        validationConfig: {
            ...basicValidation,
            accountId: {
                required: true,
                length: {
                    min: 10,
                    max: 10
                },
                number: {
                    re: /^\d+$/,
                    error: 'playtech.mobile.system.mobile-cashier.method.Ukash.accountCode.OnlyNumber.tooltip'
                }
            },
            accountPwd: {
                required: false,
                length: {
                    min: 4,
                    max: 4
                },
                number: {
                    re: /^$|^\d+$/,
                    error: 'playtech.mobile.system.mobile-cashier.method.Ukash.accountCode.OnlyNumber.tooltip'
                }
            }
        }
    },
    DotpayBlik: {
        validationConfig: {
            ...basicValidation,
            field4: {
                required: {
                    error: 'playtech.mobile.system.mobile-cashier.blik.regulations.error'
                }
            }
        }
    },
    DotpayCard: {},
    BankingPayouts: {
        isGeneric: true,
        accountFieldsMap: {
            field1: 'accountHolder',
            field2: 'accountId',
            field3: 'swift',
            field4: 'bankCity',
            field5: 'bankName'
        }
    },
    BankTransferCH: {},
    PayPalViaSC: {},
    DotpayBankTransfer: {
        validationConfig: {
            ...basicValidation,
            subMethodsCodes: {
                required: true
            },
            field4: {
                required: {
                    error: 'playtech.mobile.system.mobile-cashier.DotpayBankTransfer.regulations.error'
                }
            },
            field5: {
                required: {
                    error: 'playtech.mobile.system.mobile-cashier.DotpayBankTransfer.personaldata.error'
                }
            }
        }
    }
};

export const withdraw = mergeDeepWith(clone, deposit, {
    Envoy: {
        validationConfig: {
            amount: {
                required: true
            }
        }
    },
    EcoCard: {
        validationConfig: {
            ...basicValidation,
            accountId: {
                ...basicValidation.accountId,
                length: {
                    min: 1,
                    max: 60
                }
            }
        }
    },
    IDS: {
        validationConfig: {
            ...basicValidation,
            accountId: {
                ...basicValidation.accountId,
                length: {
                    min: 1,
                    max: 30
                },
                regexp: {
                    re: /^\w+[-+ ]\w+[-+ ]\w+$/i,
                    error: 'playtech.mobile.system.mobile-cashier.method.IDS.accountId.regexp.tooltip'
                }
            }
        }
    },
    BankTransferCH: {
        isGeneric: true
    }
});

export const portalCashierConfig = { deposit, withdraw };
